import createErrorHandler from 'utils/createErrorHandler';

function validateRescheduleForm(state) {
  const [errors, addError] = createErrorHandler();

  if (!state.academySchedule) {
    addError('schedule', 'Select a schedule to proceed!');
  }

  if (!state.startDate) {
    addError('schedule', 'Select a schedule start date to proceed!');
  }

  const selectedClasses = Object.values(state.sbatGroups).filter(
    (o) => !o.locked
  );

  if (selectedClasses.length === 0) {
    addError(
      'lectures',
      'All classes are marked as locked. Select atleast one class to proceed!'
    );
  }

  return errors;
}

export default validateRescheduleForm;
